import React from 'react';
import { Box, ListItem, Typography } from '@mui/material';
import { useTranslation } from 'react-i18next';
import { LabelNew } from '../../../../icons/label-new';
import STRING_KEYS from '../../../../language/keys';
import { style } from './style';

type NewlyCreatedItemProps = {
  text: string,
}

export const NewlyCreatedItem = ({ text }: NewlyCreatedItemProps):JSX.Element => {
  const { t: translate } = useTranslation();
  
  return (
    <ListItem>
      <Box sx={ style.boxContainer.sx }>
        <Box sx={ style.boxContainer.icon }>
          <LabelNew />
        </Box>
        <Typography
          variant={ style.boxContainer.Typography.variant }
        >
          { translate(STRING_KEYS.CREATED) }
        </Typography>
        <Typography
          variant={ style.boxContainer.Typography.variant }
          color={ style.boxContainer.Typography.text }
        >
          { text }
        </Typography>
      </Box>
    </ListItem>
  );
};
